import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";

// COMPONENTS
import Layout from "../layout/Layout";
import Icon from "../icons/Icon";
import Popover from "../popovers/Popover";
import Title from "../text/Title";

// FUNCTIONS
import generateUniqueID from "../../functions/generateUniqueID";

const ListNav = ({ type, title, list, linkTo, match, role, clicked }) => {
  const id = generateUniqueID();

  // useEffect(() => {
  //   if (scrollInView) {
  //     const activItem = document.querySelector("#activeCase452");
  //     console.log("activItem", activItem);
  //     if (activItem) activItem.scrollIntoView();
  //   }
  // }, []);

  const handleLinkClick = () => {
    if (clicked) clicked();
  };

  const generateRatingList = () =>
    list.map(item => (
      <li key={item.id}>
        <Link to={`${linkTo}/${item.id}`} onClick={handleLinkClick} className="__il c16 bc15">
          <Layout flex spaceBetween alignItemsCenter>
            <p className="__ip">{item.title}</p>
            <p>{item.score}</p>
            <Icon iconId="cup" addClass="__ii" />
          </Layout>
        </Link>
      </li>
    ));

  const generateCaseList = () =>
    list.map(item => (
      <li key={item.id}>
        <Popover msg={item.title}>
          <a
            id={`${item.id}`}
            onClick={handleLinkClick}
            href={`${linkTo}/${item.id}`}
            className={`__ir ${
              item.id === match.params.id ? "c10 bc1 listNav_active" : "c16 bc11"
            }`}
          >
            <Layout flex alignItemsCenter>
              <Icon
                iconId="checkLine"
                addClass={`__ii __if
              ${item.confirmed && item.id !== match.params.id ? "c1" : ""}
              ${item.id === match.params.id ? "c10" : "c17"}`}
                style={!item.confirmed && { opacity: ".4" }}
              />
              {item.thumbnail && (
                <div>
                  <img
                    className="__ia my myTable__image"
                    src={item.thumbnail}
                    alt={item.title}
                    onError={e => {
                      e.target.style.display = "none";
                      const svgContainer =
                        e.target.parentElement.querySelector(".myTable__image-replace");
                      if (svgContainer) svgContainer.style.display = "flex";
                    }}
                  />
                  <div className="myTable__image-replace __ia" style={{ display: "none" }}>
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      role="img"
                      width="1em"
                      height="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"></path>
                    </svg>
                  </div>
                </div>
              )}
              {!item.thumbnail && (
                <div className="myTable__image-replace __ia">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    role="img"
                    width="1em"
                    height="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"></path>
                  </svg>
                </div>
              )}
              <p className="__ip">
                {item.code ? `${item.code} - ` : ""}
                {item.title}
              </p>
            </Layout>
          </a>
        </Popover>
      </li>
    ));

  const generateSelectedCasesList = () =>
    list.map(item => (
      <li key={item.id}>
        <Popover msg={item.title}>
          <a
            id={`${item.id}`}
            onClick={handleLinkClick}
            href={`${linkTo}/${item.id}`}
            className={`__ir ${
              item.id === match.params.id ? "c10 bc1 listNav_active" : "c16 bc11"
            }`}
          >
            <Layout flex spaceBetween alignItemsCenter>
              <Layout flex alignItemsCenter>
                {item.thumbnail && (
                  <div>
                    <img
                      className="__ia my myTable__image"
                      src={item.thumbnail}
                      alt={item.title}
                      onError={e => {
                        e.target.style.display = "none";
                        const svgContainer =
                          e.target.parentElement.querySelector(".myTable__image-replace");
                        if (svgContainer) svgContainer.style.display = "flex";
                      }}
                    />
                    <div className="myTable__image-replace __ia" style={{ display: "none" }}>
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        role="img"
                        width="1em"
                        height="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"></path>
                      </svg>
                    </div>
                  </div>
                )}
                {!item.thumbnail && (
                  <div className="myTable__image-replace __ia">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      role="img"
                      width="1em"
                      height="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"></path>
                    </svg>
                  </div>
                )}
                <p className="__ip">{item.title}</p>
              </Layout>
              <Layout flex alignItemsCenter>
                <p className="__is">{item.score}</p>
              </Layout>
            </Layout>
          </a>
        </Popover>
      </li>
    ));

  return (
    <div className="__i" data-name="ListNav" data-test="ListNav">
      {title && (
        <Title addClass="__it" id={id}>
          {title}
        </Title>
      )}
      <div className="__in" data-test="ListNavList">
        <ul>
          {type === "rating" && generateRatingList()}
          {type === "cases" && generateCaseList()}
          {type === "selected_cases" && generateSelectedCasesList()}
        </ul>
      </div>
    </div>
  );
};

export default withRouter(ListNav);
